<template>
  <modal
    class="createAssetGroup"
    name="editAssetGroup"
    transition="pop-out"
    :width="800"
    :height="560"
    @opened="opened"
  >
    <div class="text-center assets_modal_div">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">{{ $t("text.editAsset.editAssetGroup") }}</p>
      <form>
        <div class="modal_form_field">
          <label class="assets_label">{{ $t("text.assets.groupName") }}</label>
          <input class="modal_input" v-model="groupValues.name" />
        </div>
        <div class="modal_form_field bas">
          <label class="assets_label">{{ $t("text.assets.groupDesc") }}</label>
          <input class="modal_input" v-model="groupValues.description" />
        </div>
        <div class="modal_form_field">
          <label class="assets_label">G{{ $t("text.assets.groupType") }}</label>
          <select class="modal_input" v-model="groupValues.groupType">
            <option value="selectGroupType" disabled>
              {{ $t("text.assets.selectGroupType") }}
            </option>
            <option value="0">{{ $t("text.assets.licensesPermits") }}</option>
            <option value="1">{{ $t("text.assets.physical") }}</option>
          </select>
        </div>
        <button
          @click="editGroup($event)"
          class="assets_button"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          {{ $t("text.editAsset.editAssetGroup") }}
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="20px"
            class="ml-3 loader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "editAssetGroup",
  props: ["group"],
  data() {
    return {
      groupValues: {},
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeModal() {
      this.$modal.hide("createAssetGroup");
    },
    editGroup(e) {
      e.preventDefault();
      if (!this.groupValues.name) {
        this.$toast.open({
          message: $t("text.assets.inputGroupName"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.groupValues.description) {
        this.$toast.open({
          message: $t("text.assets.inputDesc"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (this.groupValues.groupType == "selectGroupType") {
        this.$toast.open({
          message: $t("text.assets.selectGroupType"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        name: this.groupValues.name,
        description: this.groupValues.description,
        groupType: parseInt(this.groupValues.groupType),
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Assets/asset-groups/${this.group.id}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = true;
          this.$toast.open({
            message: $t("text.assets.successfullyEditedAssetGroup"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$eventHub.$emit("refreshAssetsGroup");
          this.$modal.hide("editAssetGroup");
        })
        .catch((e) => {
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    opened() {
      this.groupValues = this.group;
    },
  },
};
</script>
